import { graphql } from "relay-runtime"

export const deUpdateAllPatientGynaecologyMutation = graphql`
  mutation deUpdateAllPatientGynaecologyMutation($input: De_updatePatientGynaecologyInput!) {
    updateAllPatientGynaecology: de_updatePatientGynaecology(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on IneligibleForGynaecology {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      gynaecology {
        firstPeriod
        id
        menopauseSince
        patientId
        pregnancy
        pregnancyHistory
        weeksOfPregnancy
      }
    }
  }
`
